import React from "react";
import CustomCard from "../../shared/Card/CustomCard";
import CustomerForm from "./UserForm";

export default function ViewUser({ name }) {
    return (
        <CustomCard title={name}>
            <CustomerForm type="VIEW" />
        </CustomCard>
    );
}
